import React from "react";
import {
  FaFacebookF,
  FaTwitter,
  FaInstagram,
  FaLinkedinIn,
  FaYoutube,
  FaWhatsapp,
  FaTiktok,
} from "react-icons/fa";

import playstore from "./google-play.png";

const Footer = () => {
  const styles = {
    footer: {
      backgroundColor: "#0D1B2A",
      color: "#CBD5E1",
      fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
      width: "100%",
    },
    main: {
      maxWidth: "1200px",
      margin: "0 auto",
      padding: "64px 28px 48px",
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(230px, 1fr))",
      gap: "48px",
    },
    brand: {
      color: "#FFFFFF",
      fontSize: "22px",
      fontWeight: "800",
      letterSpacing: "-0.03em",
      marginBottom: "10px",
    },
    brandAccent: {
      color: "#0A9396",
    },
    tagline: {
      color: "#0A9396",
      fontStyle: "italic",
      fontSize: "14px",
      marginBottom: "16px",
    },
    h4: {
      color: "#FFFFFF",
      fontSize: "14px",
      fontWeight: "700",
      letterSpacing: "0.08em",
      textTransform: "uppercase",
      marginBottom: "16px",
      marginTop: "0",
    },
    textSmall: {
      fontSize: "14px",
      lineHeight: "1.7",
      marginBottom: "10px",
      color: "#94A3B8",
    },
    link: { color: "#CBD5E1", textDecoration: "none", fontSize: "14px", lineHeight: "2" },
    linkHover: { color: "#0A9396" },
    divider: {
      width: "32px",
      height: "2px",
      background: "#0A9396",
      marginBottom: "20px",
      borderRadius: "2px",
    },
    iconRow: {
      display: "flex",
      gap: "14px",
      marginTop: "12px",
      flexWrap: "wrap",
    },
    iconLink: {
      color: "#94A3B8",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: "36px",
      height: "36px",
      borderRadius: "8px",
      background: "rgba(255,255,255,0.05)",
      border: "1px solid rgba(255,255,255,0.08)",
      transition: "all 0.24s ease",
      textDecoration: "none",
    },
    bottomBar: {
      borderTop: "1px solid rgba(255,255,255,0.08)",
      textAlign: "center",
      padding: "22px 24px",
      fontSize: "13px",
      color: "#64748B",
    },
    playstore: { width: "150px", marginBottom: "20px", cursor: "pointer", borderRadius: "8px" },
    whatsappLink: {
      display: "flex",
      alignItems: "center",
      gap: "8px",
      color: "#CBD5E1",
      textDecoration: "none",
      fontSize: "14px",
    },
  };

  const navLinks = [
    { text: "Home", href: "/" },
    { text: "Editorial Stories", href: "/insights" },
    { text: "Book a Truck", href: "https://play.google.com/store/apps/details?id=com.MrTruck" },
    { text: "Corporate Solutions", href: "/corporate" },
    { text: "Become a Driver", href: "https://play.google.com/store/apps/details?id=com.MrTruck" },
    { text: "Pricing Guide", href: "/pricing" },
    { text: "Terms & Conditions", href: "https://mrtruckpolicies.vercel.app/" },
  ];

  const socialLinks = [
    { icon: <FaFacebookF size={15} />, href: "https://www.facebook.com/profile.php?id=61579832980204", label: "Facebook" },
    { icon: <FaTwitter size={15} />, href: "https://x.com/mrtruck_", label: "Twitter/X" },
    { icon: <FaTiktok size={15} />, href: "https://www.tiktok.com/@mr.truck59?_r=1&_t=ZS-94ZWNsEaBbc", label: "TikTok" },
    { icon: <FaInstagram size={15} />, href: "#", label: "Instagram" },
    { icon: <FaLinkedinIn size={15} />, href: "#", label: "LinkedIn" },
    { icon: <FaYoutube size={15} />, href: "#", label: "YouTube" },
  ];

  return (
    <footer style={styles.footer}>
      <div style={styles.main}>

        {/* BRAND */}
        <div>
          <div style={styles.brand}>
            MR<span style={styles.brandAccent}>TRUCK</span>
          </div>
          <p style={styles.tagline}>On-Demand Transport. Simple. Swift. Reliable.</p>
          <div style={styles.divider} />
          <p style={styles.textSmall}>
            Operated by Bridgeway Supply Chain Limited<br />
            Nairobi, Kenya
          </p>
          <p style={styles.textSmall}>
            A modern logistics platform enabling businesses and individuals to
            book trucks instantly, track deliveries, and scale transport
            operations across Africa.
          </p>
        </div>

        {/* QUICK LINKS */}
        <div>
          <h4 style={styles.h4}>Quick Links</h4>
          <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
            {navLinks.map((link, i) => (
              <li key={i}>
                <a
                  href={link.href}
                  style={styles.link}
                  onMouseOver={e => (e.currentTarget.style.color = styles.linkHover.color)}
                  onMouseOut={e => (e.currentTarget.style.color = styles.link.color)}
                >
                  {link.text}
                </a>
              </li>
            ))}
          </ul>
        </div>

        {/* CONTACT */}
        <div>
          <h4 style={styles.h4}>Contact</h4>
          <p style={styles.textSmall}>
            Westlands Business District<br />
            Nairobi, Kenya
          </p>
          <p style={styles.textSmall}>
            <strong style={{ color: "#fff" }}>Phone:</strong> +254 119 053 542
          </p>
          <p style={styles.textSmall}>
            <a
              href="mailto:support@mrtruck.co.ke"
              style={styles.link}
              onMouseOver={e => (e.currentTarget.style.color = styles.linkHover.color)}
              onMouseOut={e => (e.currentTarget.style.color = styles.link.color)}
            >
              support@mrtruck.co.ke
            </a>
          </p>
          <p style={styles.textSmall}>
            <a href="https://wa.me/254119053542" style={styles.whatsappLink}
              onMouseOver={e => (e.currentTarget.style.color = "#0A9396")}
              onMouseOut={e => (e.currentTarget.style.color = "#CBD5E1")}
            >
              <FaWhatsapp size={16} color="#25D366" />
              WhatsApp Support
            </a>
          </p>
          <p style={styles.textSmall}>
            <a
              href="https://www.mrtruck.co.ke"
              style={styles.link}
              onMouseOver={e => (e.currentTarget.style.color = styles.linkHover.color)}
              onMouseOut={e => (e.currentTarget.style.color = styles.link.color)}
            >
              www.mrtruck.co.ke
            </a>
          </p>
        </div>

        {/* DOWNLOAD + SOCIAL */}
        <div>
          <h4 style={styles.h4}>Download App</h4>
          <p style={styles.textSmall}>
            Accept jobs, book trucks, and get paid instantly after delivery.
          </p>
          <a
            href="https://play.google.com/store/apps/details?id=com.MrTruck"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={playstore} alt="Download on Play Store" style={styles.playstore} />
          </a>

          <h4 style={{ ...styles.h4, marginTop: "8px" }}>Follow Us</h4>
          <div style={styles.iconRow}>
            {socialLinks.map((s, i) => (
              <a
                key={i}
                href={s.href}
                aria-label={s.label}
                style={styles.iconLink}
                onMouseOver={e => {
                  e.currentTarget.style.color = "#0A9396";
                  e.currentTarget.style.borderColor = "#0A9396";
                  e.currentTarget.style.background = "rgba(10,147,150,0.12)";
                }}
                onMouseOut={e => {
                  e.currentTarget.style.color = "#94A3B8";
                  e.currentTarget.style.borderColor = "rgba(255,255,255,0.08)";
                  e.currentTarget.style.background = "rgba(255,255,255,0.05)";
                }}
              >
                {s.icon}
              </a>
            ))}
          </div>
        </div>
      </div>

      {/* BOTTOM BAR */}
      <div style={styles.bottomBar}>
        <p style={{ margin: "0 0 4px" }}>
          © {new Date().getFullYear()} Mr Truck — Bridgeway Supply Chain Limited
        </p>
        <p style={{ margin: 0 }}>Built for scalable logistics across Africa.</p>
      </div>
    </footer>
  );
};

export default Footer;
